import { useEffect } from 'react';
import { useGetCalendarPageQuery } from '../../app/api/pages';
import { GalleryPage } from '../../gallery-page/gallery-page';
import { Spinner } from '../../spinner/spinner';
import { PageTitle } from '../page-title/page-title';
import styles from './years-page.module.css';
import { useAppDispatch } from '../../app/hooks';
import { ModalContent, open } from '../../modal/modalSlice';
import { useNavigate, useParams } from 'react-router-dom';

export const YearsPage = ({ resetPassword }: { resetPassword?: boolean }) => {
  const { data, isLoading } = useGetCalendarPageQuery();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { token } = useParams<{ token: string }>();
  useEffect(() => {
    if (resetPassword) {
      dispatch(
        open({
          title: 'Set a new password',
          contentKey: ModalContent.ResetPassword,
          contentPayload: {
            token,
          },
        })
      );
    }
  }, [resetPassword]);
  return (
    <div className={styles.yearsPage}>
      <PageTitle title={data?.title} />
      {isLoading && <Spinner />}
      {!isLoading && data && (
        <GalleryPage
          onItemClicked={(item) => {
            switch (item.type) {
              case 'year':
                navigate(`/year/${item.id}`);
                break;
              default:
                console.error(`Unsupported item type: ${item.type}`);
            }
          }}
          {...data}
        />
      )}
    </div>
  );
};
